import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { useAuth } from '../../auth/AuthProvider.jsx';
import { authApi } from '../../api/auth.js';
import { ApiError } from '../../api/client.js';
import { Card } from '../ui/Card.jsx';
import { Input } from '../ui/Input.jsx';
import { Button } from '../ui/Button.jsx';
import { Badge } from '../ui/Badge.jsx';
import { applyServerValidation } from '../../lib/forms.js';
import { t } from '../../lib/i18n.js';

export function ProfileForm() {
  const { user, refresh } = useAuth();

  const { register, handleSubmit, reset, setError, formState: { errors } } = useForm({
    defaultValues: { firstName: '', lastName: '' }
  });

  useEffect(() => {
    if (user) reset({ firstName: user.firstName || '', lastName: user.lastName || '' });
  }, [user, reset]);

  const mutation = useMutation({
    mutationFn: (values) => authApi.updateProfile(values),
    onSuccess: async () => {
      toast.success('Profilo aggiornato.');
      await refresh();
    },
    onError: (err) => {
      const applied = applyServerValidation(err, setError);
      if (!applied) toast.error(err instanceof ApiError ? err.message : t('common.error'));
    }
  });

  return (
    <Card className="max-w-2xl">
      <header className="mb-4">
        <h2 className="text-base font-semibold text-ink">Dati personali</h2>
        <p className="text-xs text-ink-muted">Email e ruolo non sono modificabili da questa pagina.</p>
      </header>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit(mutation.mutate)} noValidate>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Input label="Email" value={user?.email || ''} disabled />
          <div className="flex items-end gap-2 pb-1">
            <span className="text-xs text-ink-muted">Ruolo</span>
            <Badge>{user?.role || (user?.roleId && (user.roleId.label || user.roleId.name)) || '-'}</Badge>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Input label="Nome" error={errors.firstName?.message} {...register('firstName', { maxLength: { value: 120, message: 'massimo 120 caratteri' } })} />
          <Input label="Cognome" error={errors.lastName?.message} {...register('lastName', { maxLength: { value: 120, message: 'massimo 120 caratteri' } })} />
        </div>
        <div className="flex justify-end">
          <Button type="submit" loading={mutation.isPending}>{t('common.save')}</Button>
        </div>
      </form>
    </Card>
  );
}
